import {Component, EventEmitter, OnInit} from '@angular/core';
import {MenuItem} from 'primeng/api';
import {ElectronService} from 'ngx-electron';
import {ActivityLogService} from '../../../activity-log/services/activity-log.service';
import {LoggerService} from '../../../logging/services/logger.service';
import {LogLevel} from '../../../logging/data/logLevel';
import {LogSource} from '../../../logging/data/logSource';
import {LogSourceType} from '../../../logging/data/logSourceType';

@Component({
  selector: 'app-side-dial',
  templateUrl: './side-dial.component.html',
  styleUrls: ['./side-dial.component.scss']
})
export class SideDialComponent implements OnInit {

  openLog: EventEmitter<void> = new EventEmitter<void>();
  openChat: EventEmitter<void> = new EventEmitter<void>();
  sideDialItems: MenuItem[];

  constructor(public electronService: ElectronService,
              public activityLogService: ActivityLogService,
              private loggerService: LoggerService) {
    this.electronService = electronService;
  }

  ngOnInit(): void {
    const logAudio = localStorage.getItem('log-audio');
    if (!logAudio) {
      localStorage.setItem('log-audio', 'true');
    }
    this.rebuildIcons();
  }

  rebuildIcons(){
    this.sideDialItems = [
      {
        icon: 'fas fa-align-left',
        command: () => {
          if (!this.activityLogService.hasLogOpenedYet) {
            this.loggerService.logMessage(LogLevel.INFO, LogSourceType.COMPONENT, LogSource.SideDialComponent, 'Opening activity log');
            this.activityLogService.firstOpenEvent.emit();
            this.activityLogService.hasLogOpenedYet = true;
          }
          this.openLog.emit();
        }
      },
      {
        icon: 'fa-solid fa-comment-alt-lines',
        command: () => {
          this.loggerService.logMessage(LogLevel.INFO, LogSourceType.COMPONENT, LogSource.SideDialComponent, 'Opening Chat');
          this.openChat.emit();
        }
      },
      {
        icon: this.getAudioIcon(),
        command: () => {
          const logAudio = localStorage.getItem('log-audio') === 'true';
          this.loggerService.logMessage(LogLevel.INFO, LogSourceType.COMPONENT, LogSource.SideDialComponent, `Setting audio logging to ${!logAudio}`);
          localStorage.setItem('log-audio', (!logAudio).toString());
          setTimeout(() => {
            this.rebuildIcons();
          }, 500);
        }
      }
    ];
  }

  getAudioIcon() {
    const audioSettings = localStorage.getItem('log-audio') === 'true';
    if (audioSettings) {
      return 'fas fa-volume-up';
    }
    return 'fas fa-volume-mute';
  }

}
